
import { BookingGender } from "@shared/core/constants";
import { DateHelper } from "@shared/core/helpers/dateHelper";
import { Format } from "@shared/core/helpers/formatHelper";
import store from "@shared/core/store";
import { Component, Vue, Prop } from "vue-property-decorator";
import { BookingConcept } from "@shared/crm/constants";
import SvgContainerSports from "@shared/crm/components/svgContainerSports.vue";
import { TranslationsHelper } from "@shared/core/helpers/translationsHelper";
import CustomerImage from "@shared/components/bookingByPlaceCard/customerImage.vue";
import { ParentNameMatch } from "@shared/core/constants";
import { BookingsHelper } from "@shared/bookings/helpers/bookingsHelper";
import { CrudService } from "@shared/core/services/crudService";
import { Settings } from "@shared/core/services/configService";

@Component({
  components: {
    SvgContainerSports,
    CustomerImage,
  },
})
export default class BookingByPlaceMatchCard extends Vue {
  @Prop({ required: true, type: Object }) booking!: any;
  @Prop({ required: false, type: String }) background!: string;

  copied: any = {};

  private get isEvent() {
    return this.booking.concept === BookingConcept.Event;
  }

  private get isMatch() {
    return this.booking.concept === BookingConcept.Match;
  }

  // private get !isDarkMode() {
  //   return this.background === "white";
  // }

  private get bookingPlayers() {
    return this.booking.players.slice(0, 4);
  }

  private get isHomePage() {
    return this.$route.name === "index";
  }

  private get isDarkMode() {
    return store.state.settings.DarkMode === true || this.isHomePage;
  }

  getImageType(logo: string) {
    if (logo !== undefined && logo !== "" && logo !== null) {
      return store.state.settings.Uploads + "/" + logo;
    }
  }
  async joinBooking(e: any, booking: any) {
    e.preventDefault();
    this.$emit("join-booking", e, booking);
  }

  getNamePlayer(player: any) {
    if (player.customerId === -1) {
      return this.$t("Free Place");
    }
    return player.name.split(" ")[0];
  }

  formatDate(dateString: string) {
    const d: any = DateHelper.toDate(
      dateString,
      store.state.settings.DateFormat
    );
    const sdate = DateHelper.toServerFormat(d);
    if (sdate !== undefined) {
      return DateHelper.beautifyDate(
        sdate,
        this.isHomePage,
        false,
        this.isHomePage,
        false,
        this.isHomePage
      );
    }
  }

  private getSportLabel(sport: any) {
    return TranslationsHelper.GetSportLabel(sport, this);
  }

  getBookingGender(gender: Number) {
    switch (gender) {
      case BookingGender.Male:
        return this.$t("Male");
      case BookingGender.Female:
        return this.$t("Female");
      case BookingGender.Mixed:
        return this.$t("Mixed");
      case BookingGender.Open:
        return this.$t("Open");
      default:
        break;
    }
  }

  getTitle() {
    if (this.isMatch) {
      return `${this.getSportLabel(this.booking.sport)} ${
        this.booking.modifyLevel ? this.$t("Competitive") : this.$t("Friendly")
      }`;
    }
    return this.booking.bookingTypeName;
  }

  getBookingPrice(price: string, netPrice: string) {
    return store.state.settings.PriceWithTaxes
      ? Format.formatCurrency(price)
      : Format.formatCurrency(netPrice);
  }

  getMinMaxLevel() {
    let msg = "";
    if (this.booking.minLevel != null) {
      msg += this.booking.minLevel.toString();
    }
    if (this.booking.maxLevel != null) {
      if (msg !== "") {
        msg += " - ";
      }
      msg += this.booking.maxLevel.toString();
    }
    return msg;
  }

  async share(booking) {
    if (navigator.share) {
      try {
        navigator.share({
          text: await this.getShareText(booking),
          url: this.bookingUrl(booking.id),
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
      return;
    }
    this.copyToClipBoard(booking.id);
  }

  async getShareText(booking: any) {
    let res: any = {};
    if (booking.isMatch) {
      res = await this.loadMatchInfoByBooking(booking.id); // to fill externalurl
      if (!res.ok) {
        return;
      }
    } else {
      res = await this.loadBookingInfo(booking.id);
    }
    const info = res.model;
    const partis = Format.convertKeysToUpperCase(info.players);

    return BookingsHelper.getShareInfo(
      booking.parentName == ParentNameMatch,
      info.tenantName,
      info.tenantAddress,
      info.url,
      info.externalUrl,
      booking.id,
      booking.maxParticipants == 0 ? 4 : booking.maxParticipants,
      partis,
      booking.dtStart,
      "",
      booking.duration,
      booking.minLevel,
      booking.maxLevel,
      booking.isVirtual ? "" : booking.resourceName,
      this
    );
  }

  bookingUrl(id: number) {
    return `${location.origin}/booking-join/${id}`;
  }

  copyToClipBoard(id: number) {
    navigator.clipboard.writeText(this.bookingUrl(id));
    this.$set(this.copied, id, true);
    setTimeout(() => {
      this.copied = [];
    }, 2000);
  }

  async loadMatchInfoByBooking(bookingId: number) {
    const url = `${
      Vue.prototype.$hostname
    }/api/matches/info-by-booking/${bookingId}`;

    try {
      const res: any = await new CrudService().httpGet(url);
      if (Format.IsNull(res) || Format.IsNull(res.model)) {
        return { ok: false, errorMsg: "crash" };
      }

      if (!res.ok) {
        return res;
      }

      return res;
    } catch (error) {
      console.error(error);
      return { ok: false, errorMsg: "crash" };
    }
  }

  async loadBookingInfo(id: number) {
    const url = `${Settings.HostName}/api/publicbookings/info/${id}`;

    try {
      const res: any = await new CrudService().httpGet(url);
      if (Format.IsNull(res) || Format.IsNull(res.model)) {
        return { ok: false, errorMsg: "crash" };
      }

      if (!res.ok) {
        return res;
      }

      return res;
    } catch (error) {
      console.error(error);
      return { ok: false, errorMsg: "crash" };
    }
  }
}
